import React from "react";
import MuiInputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "../../styles/withStyles";

function InputAdornment(props) {
  return <MuiInputAdornment {...props} />;
}

let styles = theme => ({
  root: {
    "& svg": {
      fill: theme.palette.text.secondary
    }
  },
  positionStart: {
    margin: "6px 4px 7px 0"
  },
  positionEnd: {
    margin: "6px 0 7px 4px"
  }
});

export default withStyles(styles)(InputAdornment);
